import { ChatImageAlbum } from '@/components/ChatImageAlbum';
import { resolveWidgetMediaUrl } from '@/lib/resolveWidgetMediaUrl';

export type ChatAttachmentView = {
  kind: string;
  mimeType: string;
  caption?: string;
  /** Firmada / view; ausente en adjuntos crudos (p. ej. audio de canal). */
  url?: string;
  /** Ref cruda del canal; a veces es URL reproducible para audio. */
  ref?: string;
  durationSeconds?: number;
};

function isImageAttachment(a: ChatAttachmentView): boolean {
  if (a.kind === 'image') return true;
  if (a.kind === 'video' || a.kind === 'audio' || a.kind === 'document') return false;
  return (a.mimeType || '').toLowerCase().startsWith('image/');
}

type ChatMessageAttachmentsProps = {
  attachments: ChatAttachmentView[];
};

export function ChatMessageAttachments({ attachments }: ChatMessageAttachmentsProps) {
  if (!attachments.length) return null;

  const images = attachments.filter(isImageAttachment);
  const rest = attachments.filter((a) => !isImageAttachment(a));

  return (
    <div className="chat-bubble__media">
      {images.length > 0 ? <ChatImageAlbum images={images} /> : null}
      {rest.map((a, i) => {
        if (a.kind === 'audio') {
          const rawSrc = a.url || a.ref || '';
          const src = rawSrc ? resolveWidgetMediaUrl(rawSrc) : '';
          const key = `audio-${src || a.mimeType}-${i}`;
          if (!src) {
            return (
              <div key={key} className="chat-bubble__media-audio-fallback" aria-label="Mensaje de audio">
                🎤 Audio
              </div>
            );
          }
          return (
            <audio
              key={key}
              className="chat-bubble__media-audio"
              src={src}
              controls
              preload="metadata"
            />
          );
        }

        if (!a.url) return null;

        const src = resolveWidgetMediaUrl(a.url);
        const key = `${src}-${i}`;
        if (a.kind === 'video') {
          return (
            <video
              key={key}
              className="chat-bubble__media-item"
              src={src}
              controls
              playsInline
              preload="metadata"
            />
          );
        }
        if (a.kind === 'document' || a.mimeType === 'application/pdf') {
          return (
            <a
              key={key}
              className="chat-bubble__media-doc"
              href={src}
              target="_blank"
              rel="noreferrer"
              download={a.caption || 'adjunto.pdf'}
            >
              📄 {a.caption || 'PDF'}
            </a>
          );
        }
        return null;
      })}
    </div>
  );
}
